export const RsTooltipLayout = {
  UP: 'place-top',
  DOWN: 'place-bottom',
};

export const RsTooltipAlign = {
  LEFT: '',
  RIGHT: 'left-align',
};

const clamp = (value, min, max) => Math.min(Math.max(value, min), Math.max(min, max));

export const getTooltipPlacement = ({ targetRect, popupRect, viewport, scroll, marginTop = 0 }) => {
  const targetWidth = targetRect.width || 0;
  const targetHeight = targetRect.height || 0;
  const targetRight = Number.isFinite(targetRect.right) ? targetRect.right : targetRect.left + targetWidth;
  const targetBottom = Number.isFinite(targetRect.bottom) ? targetRect.bottom : targetRect.top + targetHeight;
  const targetCenterX = targetRect.left + targetWidth / 2;
  const requiredHeight = popupRect.height + marginTop;
  const spaceAbove = targetRect.top;
  const spaceBelow = viewport.height - targetBottom;
  const isUpDirection = spaceBelow < requiredHeight && spaceAbove > spaceBelow;
  const isLeftDirection = targetCenterX + popupRect.width > viewport.width;
  const rawTop = isUpDirection ? scroll.y + targetRect.top - requiredHeight : scroll.y + targetBottom;
  const rawLeft = scroll.x + (isLeftDirection ? targetRight - targetWidth / 2 - popupRect.width : targetCenterX);
  const maxTop = scroll.y + viewport.height - requiredHeight;
  const maxLeft = scroll.x + viewport.width - popupRect.width;

  return {
    top: clamp(rawTop, scroll.y, maxTop),
    left: clamp(rawLeft, scroll.x, maxLeft),
    layout: isUpDirection ? RsTooltipLayout.UP : RsTooltipLayout.DOWN,
    align: isLeftDirection ? RsTooltipAlign.LEFT : RsTooltipAlign.RIGHT,
  };
};
